module.exports = __webpack_public_path__ + "static/media/quote5.8788958a.png";